import {
  mailboxCountsAsGraphReady,
  mailboxSendCapacity,
} from "@/utils/mailboxReadiness"
import type { Domain } from "@/types/entities/domain"

export const domainSendCapacity = (domain: Domain) => {
  if (typeof domain.availableDailyCapacity === "number") {
    return domain.availableDailyCapacity
  }
  if (typeof domain.safeDailyCapacity === "number") {
    return domain.safeDailyCapacity
  }
  if (typeof domain.domainDailyCap === "number") return domain.domainDailyCap
  return (
    domain.mailboxes
      ?.filter(mailboxCountsAsGraphReady)
      .reduce((total, mailbox) => total + mailboxSendCapacity(mailbox), 0) ?? 0
  )
}

export const selectedDomainsSendCapacity = (domains: Domain[]) => {
  let unscopedCapacity = 0
  const tenantGroups = new Map<
    string,
    { capacity: number; tenantCapacity?: number }
  >()

  for (const domain of domains) {
    const capacity = domainSendCapacity(domain)
    const tenantKey = domain.tenantCapacityKey
    if (!tenantKey) {
      unscopedCapacity += capacity
      continue
    }

    const group = tenantGroups.get(tenantKey) || { capacity: 0 }
    group.capacity += capacity
    if (typeof domain.tenantAvailableDailyCapacity === "number") {
      group.tenantCapacity =
        group.tenantCapacity === undefined
          ? domain.tenantAvailableDailyCapacity
          : Math.min(group.tenantCapacity, domain.tenantAvailableDailyCapacity)
    }
    tenantGroups.set(tenantKey, group)
  }

  return Math.max(
    0,
    Math.floor(
      unscopedCapacity +
        [...tenantGroups.values()].reduce((total, group) => {
          const capacity =
            group.tenantCapacity === undefined
              ? group.capacity
              : Math.min(group.capacity, group.tenantCapacity)
          return total + capacity
        }, 0),
    ),
  )
}
